export default {
    CM_FWU_CONNECT_TIMEOUT: 30,
    CM_CONNECT_TIMEOUT: 30,
    CM_RECONNECT_TIMEOUT: 2,
};
